import React from 'react'
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'

const MagazinesArticleWrapper = (props) => {
  const {
    sitecoreContext: { route },
    fields,
    params,
    sitecoreContext,
    t,
  } = props
  const isEditing = sitecoreContext && sitecoreContext.pageEditing

  return (
    <div>
      <Placeholder name="MagazineArticleContentZoneJssPH" rendering={props.rendering} />
    </div>
  )
}

export default withSitecoreContext()(withTranslation()(MagazinesArticleWrapper))
